module.exports = __webpack_public_path__ + "assets/img/btn_Android-71190bbc.png";